<template>
  <module-configuration :useAuthentication="false" :saveButton="false" :errors="errors"/>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ModuleConfiguration from '@/views/Configuration/Shared'

  export default {
    provide: {
      moduleDI: {
        type: 'tool',
        identifier: 'api'
      }
    },
    data: () => ({
      errors: [],
      type: 'tool',
      identifier: 'api'
    }),
    computed: {
      ...mapGetters('module', [
        'definitionEcommerceInstalled'
      ])
    },
    components: {
      ModuleConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// Api.vue?2b889641